import React, { Component } from "react";
import AnnotContext from "../../../../component/AnnotContext";
import { Rnd } from "react-rnd";
import { getPageFromElement } from "../lib/pdfjs-dom";
import "../style/AreaHighlight.css";
import type { LTWHP, ViewportHighlight } from "../types";
import { pdfAnnotElements } from "../../../../services/helper-function.service";

interface Props {
  highlight: ViewportHighlight;
  onChange: (rect: LTWHP) => void;
  isScrolledTo: boolean;
}

export class AreaHighlight extends Component<Props> {
  static contextType?: React.Context<any> = AnnotContext;
  customEle: Array<any> = pdfAnnotElements as unknown as Array<any>;

  getSelectedHighlight = (comment) => {
    let selectedOpt = { ele: {} };
    if (comment.constructor.name === "Array") {
      selectedOpt = this.customEle.find(
        (ele) => ele.key === comment[0]?.icon
      );
    } else {
      selectedOpt = this.customEle.find(
        (ele) => ele.key === comment?.icon
      );
    }
    return selectedOpt?.ele;
  };

  render() {
    const { highlight, onChange, isScrolledTo, ...otherProps } = this.props;
    const hltRectMid = highlight.position.boundingRect.top + highlight.position.boundingRect.height / 2;

    return (
      <div
        className={`AreaHighlight ${isScrolledTo ? "AreaHighlight--scrolledTo" : ""
          }`}
      >

        {highlight?.comment ? (
<button
  className="Highlight__button"
  style={{
    fontSize: '0.8em',  // Shrinks text, padding, layout
    position: 'absolute',
    left: highlight.position.boundingRect.left - 1,
    top: hltRectMid - 10,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  }}


            onClick={() => this.context?.action({
              type: 'select-annot-id',
              data: highlight?.id,
            })}
            aria-label={`Asset Number: ${(highlight.comment as any)?.assetNumber}`}
          >
            {/* Inline icon matching text height */}
            {(highlight.comment as any)?.label === this.context?.annotLabels?.tribal &&
              <span
                className="hlt-icon"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  height: '1em',      // Match text height
                }}
              >
                {this.getSelectedHighlight(highlight.comment)}
              </span>
            }

            {/* Asset number text */}
            <span style={{ lineHeight: '1em' }}>
              {(highlight.comment as any)?.assetNumber}
            </span>
          </button>
        ) : null}



        <Rnd
          className="AreaHighlight__part"
          onDragStop={(_, data) => {
            const boundingRect: LTWHP = {
              ...highlight.position.boundingRect,
              top: data.y,
              left: data.x,
            };

            onChange(boundingRect);
          }}
          onResizeStop={(_mouseEvent, _direction, ref, _delta, position) => {
            const boundingRect: LTWHP = {
              top: position.y,
              left: position.x,
              width: ref.offsetWidth,
              height: ref.offsetHeight,
              pageNumber: getPageFromElement(ref)?.number || -1,
            };

            onChange(boundingRect);
          }}
          position={{
            x: highlight.position.boundingRect.left,
            y: highlight.position.boundingRect.top,
          }}
          size={{
            width: highlight.position.boundingRect.width,
            height: highlight.position.boundingRect.height,
          }}
          onClick={(event: Event) => {
            event.stopPropagation();
            event.preventDefault();
          }}
          {...otherProps}
        />
      </div>
    );
  }
}

export default AreaHighlight;
